import { PlanUnit, PlanRound, PlanWorkout, TrainingPlan, ExerciseDTO } from '@/generated';
import { v4 } from 'uuid';

const PLAN_LENGTH = 30;

const createEmptyArray = (size: number) => new Array(size).fill(null);

export const createWorkoutUnit = (name: string, sortKey: number): PlanUnit => ({ idClient: v4(), name, workouts: [], sortKey });

export const createWorkout = (name: string, deckId: string, noOfRounds: number, sortKey: number): PlanWorkout => {
  const rounds: Array<PlanRound> = [];

  for (let index = 0; index < noOfRounds; index++) {
    rounds.push({ exercises: createEmptyArray(PLAN_LENGTH) });
  }

  return { idClient: v4(), name, rounds, deckId, sortKey };
};
export const copyWorkoutUnit = (newUnitData: PlanUnit, copiedUnit: PlanUnit): PlanUnit => ({
  ...newUnitData,
  idClient: v4(),
  workouts: copiedUnit.workouts.map((w) => ({ ...w, idClient: v4() })),
});

export const swapWorkoutUnits = (unitAId: string, unitBId: string, plan: TrainingPlan): TrainingPlan | undefined => {
  const unitA = plan?.units.find((u) => u.idClient === unitAId);
  const unitB = plan?.units.find((u) => u.idClient === unitBId);
  if (!plan || !unitA || !unitB) return;

  const newUnits = plan.units.map((u) => {
    if (u.idClient === unitA?.idClient) return { ...unitA, sortKey: unitB.sortKey };
    else if (u.idClient === unitB?.idClient) return { ...unitB, sortKey: unitA.sortKey };
    return u;
  });

  return {
    ...plan,
    units: newUnits,
  };
};

export const updateWorkoutExerciseMetrics = (workout: PlanWorkout, deckExercises: ExerciseDTO[], allExercises: ExerciseDTO[]) => {
  if (workout?.rounds) {
    workout.rounds = workout?.rounds.map((r) => ({
      exercises: r.exercises.map((e) => {
        if (e) {
          let newExercise = deckExercises?.find((ex) => e?.exerciseId === ex.id);
          if (!newExercise) newExercise = allExercises?.find((ex) => e?.exerciseId === ex.id);

          if (newExercise) {
            e.exerciseConfig = newExercise?.config;
            return e;
          }
        }

        return null;
      }),
    }));
  }
};
